interface Member {
  name: string;
  role?: string;
  imageUrl?: string;
  bio?: string;
}

interface TeamProps {
  title?: string;
  members?: Member[];
  columns?: '2' | '3' | '4';
}

export function TeamBlock({ props }: { props: TeamProps }) {
  const members = props.members ?? [];
  if (members.length === 0) return null;
  const cols = props.columns ?? '3';

  return (
    <section className="py-12 px-4">
      {props.title && <h2 className="text-2xl font-bold text-center mb-8">{props.title}</h2>}
      <div className={`grid gap-8 max-w-5xl mx-auto ${cols === '2' ? 'grid-cols-1 sm:grid-cols-2' : cols === '4' ? 'grid-cols-2 sm:grid-cols-4' : 'grid-cols-2 sm:grid-cols-3'}`}>
        {members.map((m, i) => (
          <div key={i} className="text-center">
            {m.imageUrl ? (
              <img src={m.imageUrl} alt={m.name} className="w-24 h-24 rounded-full mx-auto object-cover mb-3" loading="lazy" decoding="async" />
            ) : (
              <div className="w-24 h-24 rounded-full mx-auto bg-zinc-200 flex items-center justify-center text-2xl text-zinc-400 mb-3">
                {m.name.charAt(0)}
              </div>
            )}
            <h3 className="font-semibold text-zinc-900">{m.name}</h3>
            {m.role && <p className="text-sm text-zinc-500">{m.role}</p>}
            {m.bio && <p className="text-xs text-zinc-400 mt-1">{m.bio}</p>}
          </div>
        ))}
      </div>
    </section>
  );
}
